export interface FontSize {
  key?: string | null;
  name: string;
}
